<template>
  <div>
    <h2 class="ViewHeading">Overview</h2>
    <b-row
      ><b-col><br /></b-col
    ></b-row>
    <br />
    <b-row>
      <b-card-group class="col-md-12" deck>
        <b-card header-bg-variant="light">
          <template #header>
            <b-row>
              <b-col cols="8">
                <h5>Device Trends At A Glance</h5>
              </b-col>
            </b-row>
          </template>
          <br />
              <b-card border-variant="danger" align="center">
          <b-row>
            <b-col cols="9">
              <span class="topText"> Trending Down </span> <br />
              <span class="bottomText">
                {{ this.TrendCounts.DownTrendCount }}
              </span>
            </b-col>
            <b-col cols="3" align-self="center">
              <BIconArrowDownRightSquare
                font-scale="2"
                v-b-tooltip.hover
                title="Trending Down"
                variant="danger"
              ></BIconArrowDownRightSquare>
            </b-col>
          </b-row>
        </b-card>
        <br/>
          
           <b-card border-variant="info" align="center">
          <b-row>
            <b-col cols="9">
              <span class="topText">Stable</span>
              <br />
              <span class="bottomText">
                {{ this.TrendCounts.StableTrendCount }}
              </span>
            </b-col>
            <b-col cols="3" align-self="center">
              <BIconDashSquare
                font-scale="2"
                v-b-tooltip.hover
                title="Trending Down"
                variant="info"
              ></BIconDashSquare>
            </b-col>
          </b-row>
        </b-card>
        <br/>
            <b-card border-variant="success" align="center">
          <b-row>
            <b-col cols="9">
              <span class="topText"> Trending Up</span> <br />
              <span class="bottomText">
                {{ this.TrendCounts.UpTrendCount }}
              </span>
            </b-col>
            <b-col cols="3" align-self="center">
              <BIconArrowUpRightSquare
                font-scale="2"
                v-b-tooltip.hover
                title="Trending Up"
                variant="success"
              ></BIconArrowUpRightSquare> </b-col
          ></b-row>
        </b-card>
          <br />
        </b-card>

        <b-card header-bg-variant="light">
          <template #header>
            <b-row>
              <b-col cols="8" class="m-auto">
                <h5>Clarence Devices</h5>
              </b-col>
              <b-col cols="4" class="text-right">
                <b-button
                  variant="outline-info"
                  size="sm"
                  v-if="
                    UserAccess.includes('CLA') ||
                      profilePortal == 'SYS' ||
                      profilePortal == 'SUP'
                  "
                  v-on:click="goTo('ClarenceDevice')"
                >
                  View Details
                </b-button>
              </b-col>
            </b-row>
          </template>
          <VueApexCharts
            v-if="
              UserAccess.includes('CLA') ||
                profilePortal == 'SYS' ||
                profilePortal == 'SUP'
            "
            type="donut"
            :options="donutOptions"
            :series="donutOptions.series"
          ></VueApexCharts>
          <section
            v-if="
              !(
                this.profilePortal == 'SUP' ||
                this.profilePortal == 'SYS' ||
                this.UserAccess.includes('CLA')
              )
            "
          >
            <br />
            <NoPerms> </NoPerms>
          </section>
        </b-card>
      </b-card-group>
    </b-row>
    <br />
    <b-row>
        <b-col cols="12">
        <b-card header-bg-variant="light">
          <template #header>
            <b-row>
              <b-col cols="12">
                <h5>Current Breaches</h5>
              </b-col>
            </b-row>
          </template>
          <br />
    <Breaches/>
    </b-card>
    </b-col>
    </b-row>
    <br/>
    <b-row>
      <b-card-group class="col-md-12" deck>
        <b-card header-bg-variant="light">
          <template #header>
            <b-row>
              <b-col cols="9" class="m-auto">
                <h5>Most Recent Notifications</h5>
              </b-col>
              <b-col cols="3" class="text-right">
                <b-button
                  variant="outline-info"
                  size="sm"
                  v-on:click="goTo('Notifications')"
                  v-if="
                    UserAccess.includes('NOT') ||
                      profilePortal == 'SYS' ||
                      profilePortal == 'SUP'
                  "
                >
                  View Details
                </b-button>
              </b-col>
            </b-row>
          </template>
          <section
            v-if="
              UserAccess.includes('NOT') ||
                profilePortal == 'SYS' ||
                profilePortal == 'SUP'
            "
          >

          <b-alert
              v-for="(id, idx) in this.NotificationsArray"
              :key="idx"
              show
              variant= "light"
            >
            <b-row v-if="id.Level == '2'" class="highrisk">
               <b-col cols="2">
                  <p class="idtext">{{ getNewName(id.DeviceID) }}</p>
                </b-col>
                <b-col cols="7">
                  <p class="notetext">{{ id.Note }}</p>
                </b-col>
                 <b-col cols="2">
                  <p class="idtext">{{ id.ID }}</p>
                </b-col>
            </b-row>
            <b-row v-if="id.Level == '4'" class="infoalert">
                  <b-col cols="2">
                  <p class="idtext">{{ getNewName(id.DeviceID) }}</p>
                </b-col>
                <b-col cols="7">
                  <p class="notetext">{{ id.Note }}</p>
                </b-col>
                 <b-col cols="2">
                  <p class="idtext">{{ id.ID }}</p>
                </b-col>
            </b-row>
            <b-row v-if="id.Level == '3'" class="dangeralert">
               <b-col cols="2">
                  <p class="idtext">{{ getNewName(id.DeviceID) }}</p>
                </b-col>
                <b-col cols="7">
                  <p class="notetext">{{ id.Note }}</p>
                </b-col>
                 <b-col cols="2">
                  <p class="idtext">{{ id.ID }}</p>
                </b-col>
               
            </b-row>
            </b-alert>
          </section>
          <b-card v-if="ShowNotifications == false">
            <b-card-body class="text-center">
              There are no recent notifications for this location
            </b-card-body>
          </b-card>
          <section
            v-if="
              !(
                this.profilePortal == 'SUP' ||
                this.profilePortal == 'SYS' ||
                this.UserAccess.includes('NOT')
              )
            "
          >
            <br />
            <NoPerms> </NoPerms>
          </section>
        </b-card>
      </b-card-group>
    </b-row>
    <br />
    <b-row> </b-row>
    <b-modal
      ref="cookieModal"
      id="cookieModal"
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      title="Cookie Modal"
      content-class="Modal"
    >
      <div>
        <h3>Cookie Policy Statement</h3>

        <p>
          In Seraph Protect we uses cookies to help us show you the correct
          information and ensure the correct user details are logged. We use
          cookies to enable and support our security features, and to help us to
          detect malicious activity and any violations of our user agreement.
        </p>

        <p>
          Cookies are important to the proper function of this site. We use
          cookies to enable strictly necessary functionality such as
          Authentication & Security and Session Management. Without these
          cookies the Seraph Protect system will be unable to function.
        </p>

        <p>
          Authentication Cookies are used purely to verify a user’s identity and
          ensure that the user is logged in and has authenticated through our
          authorisation services. Authorisation is provided via Auth0 services.
        </p>

        <p>
          Session Cookies are used to manage your inputs and preferences across
          your session within the application. This means that your actions,
          data changes and preferences are remembered from page to page.
        </p>

        <p>
          Security Cookies are used to ensure and track that users are
          authorised and ensure that their access is restricted to only
          specified areas defined by their user access group.
        </p>

        <p>
          These cookies are used solely for the purposes outlined above and are
          not persisted beyond the current session, they are deleted when you
          log out.
        </p>

        <br />

        <div id="cookieButton">
          <b-button variant="info" class="button" v-on:click="acceptModal()">
            Ok
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import store from "../store";
import { IDToHuman } from "../CustomFunctions/HumanName.js";
import Breaches from "../components/SeniorUserComponents/Breaches.vue"

import {
  BIconArrowDownRightSquare,
  BIconDashSquare,
  BIconArrowUpRightSquare,
} from "bootstrap-vue";
import NoPerms from "../components/NoPermsPage.vue";

import VueApexCharts from "vue-apexcharts";

export default {
  computed: {},
  components: {
    BIconArrowDownRightSquare,
    BIconDashSquare,
    BIconArrowUpRightSquare,
    VueApexCharts,
    NoPerms,
    Breaches
  },

  data() {
    return {
      DeviceIDToChange: { C1: [], O1: [] },
      IDsIhaveChanged: { C1: [], O1: [] },
      IDsToChange: { C1: [], O1: [] },
      screenWidth: 0,
      ShowNotifications: false,
      NotificationsArray: [],
      UserURN: localStorage.getItem("UserURN"),
      UserAccess: localStorage.getItem("accessGroup"),
      profilePortal: localStorage.getItem("profileportal"),
      donutOptions: {
        series: [1, 1, 1, 1],
        labels: [
          "Extremely high risk",
          "High risk",
          "Moderate risk",
          "Low risk",
        ],
        dataLables: {
          enabled: false,
        },
        colors: ["#dc3545", "#F05E16", "#ffc107", "#28a745"],
      },
      TrendCounts: {
        DownTrendCount: "--",
        UpTrendCount: "--",
        StableTrendCount: "--",
      },

      options: {
        legend: {
          display: false,
        },
        tooltips: {
          enabled: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },

      file: "",
      DeviceID: "",
      Folder: "attachments",
      items: [],
      UserHeaders: [],
      response: null,
      ArrTest: [],
      perPage: 5,
      currentPage: 1,
      rowDblClickHandler: "",
      modal: false,
      item0: "",
      item1: "",
      item2: "",
      item3: "",
      item4: "",
      showOverlay: false,
      duplicatefile: false,

      selectedlocation: localStorage.getItem("CurrentLocation"),

      AlertBoxCounts: "",
    };
  },

  beforeMount() {
    this.themepref = store.state.themepref;
    this.themepref = store.state.themepref;
    this.userType = store.state.profileportal;
    this.UserURNSubmit = store.state.UserURN;
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/userlookups";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "Consent",
      FirstName: "",
      LastName: "",
      UserURN: localStorage.getItem("UserURN"),
    };
    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
        this.cookieAccept = response.data.Values[0][0];
        localStorage.cookieAccept = this.cookieAccept;
        if (this.cookieAccept == "FALSE") {
          this.showModal();
        }
      });
  },

  mounted() {
    this.updateScreenWidth();
    this.onScreenResize();
    let LookUpUrlData =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/dashboard";
    let LookUpHeadersData = this.$apikeyPost;
    this.LookUpRequest = {
      Report: "Overview",
      RequestVariable: this.selectedlocation,
    };
    axios
      .post(LookUpUrlData, this.LookUpRequest, LookUpHeadersData)
      .then((response) => {
        let NotificationsList = response.data.FiveRecentAlerts;
        this.NotificationsArray = [];
        if (NotificationsList.length != 0) {
          this.ShowNotifications = true;
        }
        for (let i = 0; i < NotificationsList.length; i++) {
          let color = "";
          let ClarenceType = "";

          if (NotificationsList[i][1][0] == "e") {
            ClarenceType = "O1";
          } else {
            ClarenceType = "C1";
          }

          this.IDGetArrays(NotificationsList[i][1], ClarenceType);
          if (NotificationsList[i][5] == "3") {
            color = "danger";
          } else if (NotificationsList[i][5] == "2") {
            color = "warning";
          } else if (NotificationsList[i][5] == "1") {
            color = "success";
          } else if (NotificationsList[i][5] == "4") {
            color = "info";
          }
          this.NotificationsArray.push({
            Level: NotificationsList[i][5],
            ID: NotificationsList[i][0],
            DeviceID: NotificationsList[i][1],
            Note: NotificationsList[i][4],
            variantColor: color,
          });
        }
        this.SwitchToHuman("O1");
        this.SwitchToHuman("C1");

        // (this.seriesLineColony = [
        //   {
        //     name: "Fail",
        //     data: [response.data.WaterTestResults.ColonyTests.Fail],
        //   },
        //   {
        //     name: "Pass",
        //     data: [response.data.WaterTestResults.ColonyTests.Pass],
        //   },
        // ]),
        //   (this.seriesLineRapid = [
        //     {
        //       name: "Fail",
        //       data: [response.data.WaterTestResults.RapidTests.Fail],
        //     },
        //     {
        //       name: "Pass",
        //       data: [response.data.WaterTestResults.RapidTests.Pass],
        //     },
        //   ]);
        // INSERT FOR LOOP TO MAKE NOTIFICATIONS
        this.TrendCounts = {
          UpTrendCount: response.data.TrendCounts.UpTrendCount,
          DownTrendCount: response.data.TrendCounts.DownTrendCount,
          StableTrendCount: response.data.TrendCounts.StableTrendCount,
        };

        this.AlertBoxCounts = response.data.AlertBoxCounts;

        // this.chartOptionsLine = {
        //   dataLabels: {
        //     enabled: false,
        //   },

        //   title: {
        //     text: "7 Day Handwash Flow Data",
        //     align: "center",
        //   },

        //   legend: {
        //     show: true,
        //   },
        //   chart: {},
        //   sparkline: {
        //     enabled: true,
        //   },
        //   fill: {
        //     opacity: 1,
        //   },

        //   xaxis: {
        //     categories: response.data.SevenDayFlows.DateList,

        //     labels: {
        //       show: true,
        //     },
        //   },
        //   yaxis: {
        //     labels: {
        //       show: true,
        //     },
        //   },
        //   colors: ["#17a2b8", "#7BF0B7"],
        //   grid: {
        //     show: true, // you can either change hear to disable all grids
        //     xaxis: {
        //       lines: {
        //         show: true, //or just here to disable only x axis grids
        //       },
        //       labels: {
        //         show: false,
        //       },
        //     },
        //     yaxis: {
        //       lines: {
        //         show: false, //or just here to disable only y axis
        //       },
        //       axisBorder: {
        //         show: false,
        //       },
        //       labels: {
        //         show: false,
        //       },
        //       axisTicks: {
        //         show: false,
        //       },
        //     },
        //   },
        // };
        // this.seriesLine = [
        //   {
        //     name: "No of Flushes",
        //     data: response.data.SevenDayFlows.SevenDayFlushes,
        //   },
        //   {
        //     name: "No of Handwashes",
        //     data: response.data.SevenDayFlows.SevenDayHandwashes,
        //   },
        // ];
        // (this.seriesLine = [
        //   {
        //     name: "No of Handwashes",
        //     data: response.data.SevenDayFlows.SevenDayHandwashes,
        //   },
        //   {
        //     name: "No of Flushes",
        //     data: response.data.SevenDayFlows.SevenDayFlushes,
        //   },
        // ]),
          (this.donutOptions = {
            series: [
              response.data.RiskLevelCounts.ExtremelyHighRiskCount,
              response.data.RiskLevelCounts.HighRiskCount,
              response.data.RiskLevelCounts.ModerateRiskCount,
              response.data.RiskLevelCounts.LowRiskCount,
            ],
            labels: [
              "Extremely High Risk",
              "High Risk",
              "Moderate Risk",
              "Low Risk",
            ],
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    total: {
                      show: true,
                      color: "#000000"
                    },
                  },
                },
              },
            },

            dataLables: {
              enabled: false,
            },
            legend: {
              show: true,
            },

            colors: ["#dc3545", "#F05E16", "#ffc107", "#28a745"],
          });
      });
  },

  methods: {
    async SwitchToHuman(Type) {
      if (Type == "O1") {
        let Names = await IDToHuman(this.IDsToChange.O1, Type);

        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.O1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.O1.push({
            ID: this.IDsToChange.O1[q],
            Name: Names[q],
          });
        }
      }

      if (Type == "C1") {
        let Names = await IDToHuman(this.IDsToChange.C1, Type);

        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.C1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.C1.push({
            ID: this.IDsToChange.C1[q],
            Name: Names[q],
          });
        }
      }
    },
    getNewName(data) {
      let ClarenceType = "";

      if (data[0] == "e") {
        ClarenceType = "O1";
      } else {
        ClarenceType = "C1";
      }

      if (ClarenceType == "O1") {
        for (let i = 0; i < this.DeviceIDToChange.O1.length; i++) {
          if (data == this.DeviceIDToChange.O1[i].ID) {
            return this.DeviceIDToChange.O1[i].Name;
          }
        }
      } else {
        for (let i = 0; i < this.DeviceIDToChange.C1.length; i++) {
          if (data == this.DeviceIDToChange.C1[i].ID) {
            return this.DeviceIDToChange.C1[i].Name;
          }
        }
      }
      return data;
    },

    async IDGetArrays(ID, Type) {
      if (Type == "C1") {
        if (
          this.IDsIhaveChanged.C1.includes(ID) ||
          this.IDsToChange.C1.includes(ID)
        ) {
          return;
        } else if (
          this.IDsIhaveChanged.C1.includes(ID) == false &&
          this.IDsToChange.C1.includes(ID) == false
        ) {
          this.IDsToChange.C1.push(ID);
        }
      }
      if (Type == "O1") {
        if (
          this.IDsIhaveChanged.O1.includes(ID) ||
          this.IDsToChange.O1.includes(ID)
        ) {
          return;
        } else if (
          this.IDsIhaveChanged.O1.includes(ID) == false &&
          this.IDsToChange.O1.includes(ID) == false
        ) {
          this.IDsToChange.O1.push(ID);
        }
      }
    },

    onScreenResize() {
      window.addEventListener("resize", () => {
        this.updateScreenWidth();
      });
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    showActionModal(var0, var1, var2, var3, var4) {
      this.item0 = var0;
      this.item1 = var1;
      this.item2 = var2;
      this.item3 = var3;
      this.item4 = var4;
      this.$refs["DeviceAttachModal"].show(
        this.item0,
        this.item1,
        this.item2,
        this.item3,
        this.item4
      );
    },

    resetValue() {
      this.file = "";
      document.getElementById("file-upload").value = null;
    },

    resetmodal() {
      this.$refs["DeviceAttachModal"].hide();
    },
    goTo(Location) {
      if (Location == "AGWashbasinUnits") {
        this.$router.push("/WashbasinDashboard");
      } else if (Location == "Notifications") {
        this.$router.push("/AlertsOverview");
      } else if (Location == "TestResults") {
        this.$router.push("/WaterManagementOverview");
      } else if (Location == "ClarenceDevice") {
        this.$router.push("/Dashboard");
      }
    },
    showModal() {
      this.$refs["cookieModal"].show();

      // this.$bvModal.show("cookieModal");
    },
    acceptModal() {
      this.cookieAccept = "TRUE";
      localStorage.cookieAccept = this.cookieAccept;
      this.LookUpRequest = {
        RequestType: "UpdateConsent",
        UserType: this.profileportal,
        UserDict: [{ UserURN: this.UserURN, ConsentGiven: "TRUE" }],
      };

      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/useradmin";
      let LookUpHeaders = this.$apikeyPost;
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          response;
        });

      this.$refs["cookieModal"].hide();
    },

    closeModal() {
      this.$refs["cookieModal"].hide();
    },
  },
};
</script>

<style>
.bv-example-row {
  background-color: whitesmoke;
  border: 3px;
  border-color: darkgray;
  border-style: solid;
  padding: 10px;
}

canvas {
  background-color: white;
  border: 1pt;
  border-style: solid;
  border-color: darkgray;
}

.card-link {
  text-decoration: underline;
  color: black;
  font-style: italic;
}

caption {
  color: black;
  padding-bottom: 0;
}
.Red {
  background-color: red;
  color: white;
  text-align: center;
}
.Amber {
  background-color: orange;
  color: black;
  text-align: center;
}
.Green {
  background-color: green;
  color: white;
  text-align: center;
}
.Red,
.Amber,
.Green {
  border-radius: 25px;
  padding: 5px;
}

.AGCountsColor {
  background-color: rgb(78, 205, 196);
  color: #FFFFFF;
}

.totalBox {
  padding: 1rem 1.5rem 1rem 1.5rem;
  text-align: center;
  width: 100%;
  background-color: #eeeeee;
  border: 0px;
  border-radius: 15px;
}

.bottomText {
  font-size: 1.4rem;
  font-weight: 600;
  margin: none !important;
  padding: none !important;
  color: #0c0c0c;
}
.topText {
  font-size: 1.1rem;
  font-style: italic;
}

.idtext {
  margin-top: 5px;
  font-size: small;
  margin-bottom: 5px;
  font-weight: bold;
}

.notetext {
  margin-top: 5px;
  font-size: small;
  margin-bottom: 5px;
}
.alert-light {
    color: #525252;
    background-color: #fefefe;
    border-color: #818182;
}
.infoalert{
  background-color: #17a2b8;
  color: black;
}
.dangeralert{
  background-color: #dc3545;
  color: black;
}
</style>
